/**
 * Force Size Selection — buttonsbebe.com
 * ---------------------------------------
 * Product cards pre-select a default size internally (usually the first
 * available one) so the Add to Cart button always has a valid variant to
 * submit. That's normally invisible to the customer. This script requires
 * the customer to actually click a size before Add to Cart is allowed to
 * go through, on any card that has more than one size to choose from.
 */
(function () {
  'use strict';

  function getCard(el) {
    return el.closest('.m-product-card');
  }

  function getPicker(card) {
    return card && card.querySelector('[data-pcard-variant-picker]');
  }

  function needsSelection(card) {
    // Only cards with an actual variant picker (i.e. more than one size) apply
    return !!getPicker(card);
  }

  function hasSelection(card) {
    return card.dataset.sizeSelected === 'true';
  }

  function markSelected(card) {
    card.dataset.sizeSelected = 'true';
    var picker = getPicker(card);
    if (picker) picker.classList.remove('m-size-picker--needs-selection');
  }

  function flagPicker(card) {
    var picker = getPicker(card);
    if (!picker) return;
    picker.classList.add('m-size-picker--needs-selection');
    picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    setTimeout(function () {
      picker.classList.remove('m-size-picker--needs-selection');
    }, 1200);
  }

  // A size button was clicked — mark this card as having an explicit selection.
  // Runs in the bubble phase, same as the theme's own swatch handler, just
  // recording that a real click happened (not touching variant logic at all).
  document.addEventListener('click', function (e) {
    var label = e.target.closest('.m-product-option--node__label');
    if (!label) return;
    var card = getCard(label);
    if (card) markSelected(card);
  });

  // Intercept the add-to-cart submission BEFORE the theme's own handler,
  // using the capture phase so this runs first regardless of listener order.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form.classList || !form.classList.contains('product-card-form')) return;
      var card = getCard(form);
      if (!card) return;
      if (needsSelection(card) && !hasSelection(card)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        flagPicker(card);
      }
    },
    true
  );
})();